var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-table-simple",
        {
          ref: "detailGrid",
          staticStyle: { "max-height": "65vh", "font-size": "12px" },
          attrs: { bordered: "", responsive: "", "sticky-header": "" },
        },
        [
          _c("colgroup", [
            _c("col", { staticStyle: { width: "130px" } }),
            _c("col", { staticStyle: { width: "150px" } }),
            _c("col", { staticStyle: { width: "100px" } }),
            _c("col", { staticStyle: { width: "100px" } }),
            _c("col", { staticStyle: { width: "100px" } }),
            _c("col", { staticStyle: { width: "100px" } }),
            _c("col", { staticStyle: { width: "100px" } }),
            _c("col", { staticStyle: { width: "100px" } }),
            _c("col", { staticStyle: { width: "100px" } }),
            _c("col", { staticStyle: { width: "100px" } }),
            _c("col", { staticStyle: { width: "105px" } }),
            _c("col", { staticStyle: { width: "90px" } }),
            _c("col", { staticStyle: { width: "90px" } }),
            _c("col", { staticStyle: { width: "90px" } }),
          ]),
          _c(
            "b-thead",
            { attrs: { "head-variant": "light" } },
            [
              _c(
                "b-tr",
                [
                  _c(
                    "b-th",
                    { staticClass: "sticky-header", attrs: { rowspan: "2" } },
                    [_vm._v(" 조회일자 ")]
                  ),
                  _c(
                    "b-th",
                    { staticClass: "sticky-header", attrs: { rowspan: "2" } },
                    [_vm._v(" 진료과 ")]
                  ),
                  _c("b-th", { attrs: { colspan: "2" } }, [
                    _vm._v(" 닥터인포 "),
                  ]),
                  _c("b-th", { attrs: { colspan: "2" } }, [
                    _vm._v(" 처방팝업 "),
                  ]),
                  _c("b-th", { attrs: { colspan: "2" } }, [
                    _vm._v(" 스케줄팝업 "),
                  ]),
                  _c("b-th", { attrs: { colspan: "2" } }, [
                    _vm._v(" 진료후팝업 "),
                  ]),
                  _c("b-th", { attrs: { rowspan: "2" } }, [
                    _vm._v(" 총 클릭 수 "),
                  ]),
                  _c("b-th", { attrs: { colspan: "3" } }, [
                    _vm._v(" 상세보기 클릭 수 "),
                  ]),
                ],
                1
              ),
              _c(
                "b-tr",
                [
                  _c("b-th", { staticStyle: { top: "38.55px" } }, [
                    _vm._v(" 노출 수 "),
                  ]),
                  _c("b-th", { staticStyle: { top: "38.55px" } }, [
                    _vm._v(" 클릭 수 "),
                  ]),
                  _c("b-th", { staticStyle: { top: "38.55px" } }, [
                    _vm._v(" 노출 수 "),
                  ]),
                  _c("b-th", { staticStyle: { top: "38.55px" } }, [
                    _vm._v(" 클릭 수 "),
                  ]),
                  _c("b-th", { staticStyle: { top: "38.55px" } }, [
                    _vm._v(" 노출 수 "),
                  ]),
                  _c("b-th", { staticStyle: { top: "38.55px" } }, [
                    _vm._v(" 클릭 수 "),
                  ]),
                  _c("b-th", { staticStyle: { top: "38.55px" } }, [
                    _vm._v(" 노출 수 "),
                  ]),
                  _c("b-th", { staticStyle: { top: "38.55px" } }, [
                    _vm._v(" 클릭 수 "),
                  ]),
                  _c("b-th", { staticStyle: { top: "38.55px" } }, [
                    _vm._v(" 탭1 "),
                  ]),
                  _c("b-th", { staticStyle: { top: "38.55px" } }, [
                    _vm._v(" 탭2 "),
                  ]),
                  _c("b-th", { staticStyle: { top: "38.55px" } }, [
                    _vm._v(" 탭3 "),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm.data && _vm.data.statistics && _vm.data.statistics.length > 0
            ? _c(
                "b-tbody",
                [
                  _vm._l(_vm.data.statistics, function (detail) {
                    return [
                      _vm._l(detail.detailDepts, function (member, index) {
                        return [
                          _c(
                            "b-tr",
                            { key: "member-" + detail.yyyymmdd + "-" + index },
                            [
                              index === 0
                                ? _c(
                                    "b-td",
                                    {
                                      staticStyle: { left: "0" },
                                      attrs: {
                                        rowspan:
                                          detail.detailDepts.length > 0
                                            ? detail.detailDepts.length
                                            : 0,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("$dateFormatter")(
                                              detail.yyyymmdd,
                                              "YYYY-MM-DD"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c("b-td", { staticStyle: { left: "95px" } }, [
                                _vm._v(" " + _vm._s(member.medicalDept) + " "),
                              ]),
                              _c("b-td", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("$numberFormatter")(
                                      member.totalMainOpenCount
                                    )
                                  )
                                ),
                              ]),
                              _c("b-td", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("$numberFormatter")(
                                      member.totalMainClickCount
                                    )
                                  )
                                ),
                              ]),
                              _c("b-td", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("$numberFormatter")(
                                      member.totalPrescriptionOpenCount
                                    )
                                  )
                                ),
                              ]),
                              _c("b-td", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("$numberFormatter")(
                                      member.totalPrescriptionClickCount
                                    )
                                  )
                                ),
                              ]),
                              _c("b-td", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("$numberFormatter")(
                                      member.totalScheduleOpenCount
                                    )
                                  )
                                ),
                              ]),
                              _c("b-td", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("$numberFormatter")(
                                      member.totalScheduleClickCount
                                    )
                                  )
                                ),
                              ]),
                              _c("b-td", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("$numberFormatter")(
                                      member.totalAfterConsultOpenCount
                                    )
                                  )
                                ),
                              ]),
                              _c("b-td", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("$numberFormatter")(
                                      member.totalAfterConsultClickCount
                                    )
                                  )
                                ),
                              ]),
                              _c("b-td", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("$numberFormatter")(
                                      member.totalClickCount
                                    )
                                  )
                                ),
                              ]),
                              _c("b-td", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("$numberFormatter")(
                                      member.totalTabClickCount1
                                    )
                                  )
                                ),
                              ]),
                              _c("b-td", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("$numberFormatter")(
                                      member.totalTabClickCount2
                                    )
                                  )
                                ),
                              ]),
                              _c("b-td", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("$numberFormatter")(
                                      member.totalTabClickCount3
                                    )
                                  )
                                ),
                              ]),
                            ],
                            1
                          ),
                        ]
                      }),
                      detail.detailDepts.length > 0
                        ? _c(
                            "b-tr",
                            { key: "member-total-" + detail.yyyymmdd },
                            [
                              _c(
                                "b-td",
                                {
                                  staticStyle: {
                                    "text-align": "center",
                                    left: "0px",
                                  },
                                  attrs: { colspan: "2" },
                                },
                                [_vm._v(" 소계 ")]
                              ),
                              _c("b-td", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("$numberFormatter")(
                                      detail.detailDepts.reduce(function (
                                        f,
                                        l
                                      ) {
                                        return f + l.totalMainOpenCount
                                      },
                                      0)
                                    )
                                  )
                                ),
                              ]),
                              _c("b-td", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("$numberFormatter")(
                                      detail.detailDepts.reduce(function (
                                        f,
                                        l
                                      ) {
                                        return f + l.totalMainClickCount
                                      },
                                      0)
                                    )
                                  )
                                ),
                              ]),
                              _c("b-td", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("$numberFormatter")(
                                      detail.detailDepts.reduce(function (
                                        f,
                                        l
                                      ) {
                                        return f + l.totalPrescriptionOpenCount
                                      },
                                      0)
                                    )
                                  )
                                ),
                              ]),
                              _c("b-td", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("$numberFormatter")(
                                      detail.detailDepts.reduce(function (
                                        f,
                                        l
                                      ) {
                                        return f + l.totalPrescriptionClickCount
                                      },
                                      0)
                                    )
                                  )
                                ),
                              ]),
                              _c("b-td", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("$numberFormatter")(
                                      detail.detailDepts.reduce(function (
                                        f,
                                        l
                                      ) {
                                        return f + l.totalScheduleOpenCount
                                      },
                                      0)
                                    )
                                  )
                                ),
                              ]),
                              _c("b-td", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("$numberFormatter")(
                                      detail.detailDepts.reduce(function (
                                        f,
                                        l
                                      ) {
                                        return f + l.totalScheduleClickCount
                                      },
                                      0)
                                    )
                                  )
                                ),
                              ]),
                              _c("b-td", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("$numberFormatter")(
                                      detail.detailDepts.reduce(function (
                                        f,
                                        l
                                      ) {
                                        return f + l.totalAfterConsultOpenCount
                                      },
                                      0)
                                    )
                                  )
                                ),
                              ]),
                              _c("b-td", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("$numberFormatter")(
                                      detail.detailDepts.reduce(function (
                                        f,
                                        l
                                      ) {
                                        return f + l.totalAfterConsultClickCount
                                      },
                                      0)
                                    )
                                  )
                                ),
                              ]),
                              _c("b-td", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("$numberFormatter")(
                                      detail.detailDepts.reduce(function (
                                        f,
                                        l
                                      ) {
                                        return f + l.totalClickCount
                                      },
                                      0)
                                    )
                                  )
                                ),
                              ]),
                              _c("b-td", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("$numberFormatter")(
                                      detail.detailDepts.reduce(function (
                                        f,
                                        l
                                      ) {
                                        return f + l.totalTabClickCount1
                                      },
                                      0)
                                    )
                                  )
                                ),
                              ]),
                              _c("b-td", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("$numberFormatter")(
                                      detail.detailDepts.reduce(function (
                                        f,
                                        l
                                      ) {
                                        return f + l.totalTabClickCount2
                                      },
                                      0)
                                    )
                                  )
                                ),
                              ]),
                              _c("b-td", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("$numberFormatter")(
                                      detail.detailDepts.reduce(function (
                                        f,
                                        l
                                      ) {
                                        return f + l.totalTabClickCount3
                                      },
                                      0)
                                    )
                                  )
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  }),
                  _c(
                    "b-tr",
                    [
                      _c(
                        "b-td",
                        {
                          staticStyle: { "text-align": "center", left: "0px" },
                          attrs: { colspan: "2" },
                        },
                        [_vm._v(" 합계 ")]
                      ),
                      _c("b-td", [
                        _vm._v(
                          _vm._s(
                            _vm._f("$numberFormatter")(
                              _vm.grandTotal.totalMainOpenCount
                            )
                          )
                        ),
                      ]),
                      _c("b-td", [
                        _vm._v(
                          _vm._s(
                            _vm._f("$numberFormatter")(
                              _vm.grandTotal.totalMainClickCount
                            )
                          )
                        ),
                      ]),
                      _c("b-td", [
                        _vm._v(
                          _vm._s(
                            _vm._f("$numberFormatter")(
                              _vm.grandTotal.totalPrescriptionOpenCount
                            )
                          )
                        ),
                      ]),
                      _c("b-td", [
                        _vm._v(
                          _vm._s(
                            _vm._f("$numberFormatter")(
                              _vm.grandTotal.totalPrescriptionClickCount
                            )
                          )
                        ),
                      ]),
                      _c("b-td", [
                        _vm._v(
                          _vm._s(
                            _vm._f("$numberFormatter")(
                              _vm.grandTotal.totalScheduleOpenCount
                            )
                          )
                        ),
                      ]),
                      _c("b-td", [
                        _vm._v(
                          _vm._s(
                            _vm._f("$numberFormatter")(
                              _vm.grandTotal.totalScheduleClickCount
                            )
                          )
                        ),
                      ]),
                      _c("b-td", [
                        _vm._v(
                          _vm._s(
                            _vm._f("$numberFormatter")(
                              _vm.grandTotal.totalAfterConsultOpenCount
                            )
                          )
                        ),
                      ]),
                      _c("b-td", [
                        _vm._v(
                          _vm._s(
                            _vm._f("$numberFormatter")(
                              _vm.grandTotal.totalAfterConsultClickCount
                            )
                          )
                        ),
                      ]),
                      _c("b-td", [
                        _vm._v(
                          _vm._s(
                            _vm._f("$numberFormatter")(
                              _vm.grandTotal.totalClickCount
                            )
                          )
                        ),
                      ]),
                      _c("b-td", [
                        _vm._v(
                          _vm._s(
                            _vm._f("$numberFormatter")(
                              _vm.grandTotal.totalTabClickCount1
                            )
                          )
                        ),
                      ]),
                      _c("b-td", [
                        _vm._v(
                          _vm._s(
                            _vm._f("$numberFormatter")(
                              _vm.grandTotal.totalTabClickCount2
                            )
                          )
                        ),
                      ]),
                      _c("b-td", [
                        _vm._v(
                          _vm._s(
                            _vm._f("$numberFormatter")(
                              _vm.grandTotal.totalTabClickCount3
                            )
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                2
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }